import { render, staticRenderFns } from "./dtzpffb.vue?vue&type=template&id=27494eee&"
import script from "./dtzpffb.vue?vue&type=script&lang=js&"
export * from "./dtzpffb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports